import { render, staticRenderFns } from "./FoldersNavigator.vue?vue&type=template&id=3f25e1ca&scoped=true&"
import script from "./FoldersNavigator.vue?vue&type=script&lang=js&"
export * from "./FoldersNavigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f25e1ca",
  null
  
)

export default component.exports